import { render } from "./SearchWordsIndex.vue?vue&type=template&id=7a7cd2b6"
import script from "./SearchWordsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchWordsIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/search-words/components/SearchWordsIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a7cd2b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a7cd2b6', __exports__)) {
    api.reload('7a7cd2b6', __exports__)
  }
  
  module.hot.accept("./SearchWordsIndex.vue?vue&type=template&id=7a7cd2b6", () => {
    api.rerender('7a7cd2b6', render)
  })

}


export default __exports__